import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoStetoLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 1080,
	height: 1080,
	viewBox: "0 0 1080 1080",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M799.319 727.613C810.092 727.613 816.915 738.96 812.103 748.584C763.41 845.969 659.92 913.334 540.415 913.334C375.018 913.334 240 783.415 240 623.046C240 462.676 374.946 332.757 540.415 332.757C705.884 332.757 840.83 462.676 840.83 623.046C840.83 637.265 839.825 650.48 837.814 663.623H366.903C385.144 743.772 456.244 803.668 540.487 803.668C598.731 803.668 650.44 775.874 682.328 733.502C685.128 729.839 689.366 727.541 693.962 727.541H799.391L799.319 727.613ZM368.913 572.342H711.917C690.587 497.22 621.569 442.423 540.415 442.423C459.261 442.423 391.249 497.22 368.913 572.342Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M720.61 239.609C720.61 243.631 717.45 246.863 713.428 246.863C683.337 246.719 606.204 247.078 580.996 246.719C555.429 247.15 407.555 246.719 367.337 246.863C363.315 246.863 360.155 243.631 360.155 239.609L360.586 174.111C360.586 170.161 363.818 166.929 367.768 167.001C407.771 167.288 555.572 166.714 580.924 167.288C605.988 166.786 683.049 167.288 712.926 167.073C716.876 167.073 720.107 170.233 720.107 174.183L720.538 239.681L720.61 239.609Z",
		fill: "#58F2BB"
	})]
});
export default SvgLogoStetoLight;
